import { useMutation } from '@apollo/client';
import {
  ALL_TABLES,
  AppContext,
  DeleteModal,
  EventEmitter,
  ResetFilter,
  Tag,
  getTranslatedText,
  useSuperListHook
} from '@nile/components';
import { AccountClient, DELETE_UNKNOWN_EMAILS } from '@nile/graphql';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { Button, ButtonGroup, Heading } from '@superops/ui-design-system';
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';

import { SVGIcon } from '@superops/super-icons';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';

const StyledToolbar = styled.div`
  height: 90px;
  background: #ffffff;
  border-bottom: 1px solid #e7e7e7;
  padding: 20px;
  .ticketing-modify {
    display: flex;
    align-items: center;
  }
  .navMenu .Polaris-Button {
    padding: 0 10px !important;
  }
  .navMenu {
    margin-right: 20px !important;
  }
`;

const ToolbarWrapper = styled.div`
  .tag {
    font-size: 12px !important;
    padding: 2px 6px !important;
    margin-left: 12px !important;
  }
  .Polaris-Heading {
    font-weight: 500 !important;
  }
  .danger {
    color: #e02020;
  }
`;

const IconHolder = styled.div`
  cursor: pointer;
`;

function TicketInfoToolbar(props) {
  const { intl, context, activeView, params } = props;

  return (
    <ToolbarWrapper className="flex full-width">
      <Heading element="h1" weight="Medium">
        <div className="flex center">
          <div className="flex center">
            <div className="mr8 navMenu" onClick={props.toggleNavMenu}>
              {props.navMenu}
            </div>
            {activeView}
          </div>
        </div>
      </Heading>
    </ToolbarWrapper>
  );
}

function MailActionToolbar(props) {
  const { intl, records, setRecords, params, tableName, viewId } = props;

  const [deleteUnknownEmails] = useMutation(DELETE_UNKNOWN_EMAILS, {
    client: AccountClient
  });

  const modalActivator = (
    <Button id="mailActivator" customClassName="action-button p-0">
      <div className="flex actr danger">
        <IconHolder className="mr8">
          <SVGIcon name="Delete" color="#E02020" />
        </IconHolder>
        <FormattedMessage id="mail.unknown.bulk.delete.title" />
      </div>
    </Button>
  );

  return (
    <ToolbarWrapper className="flex full-width">
      <div className="mlauto">
        <ResetFilter tableName={tableName} viewId={viewId} className="mr10" />
        {records?.length > 0 && (
          <ButtonGroup>
            <Tag>{`${records.length} ${getTranslatedText(
              intl,
              'ticket.details.selected'
            )}`}</Tag>
            <DeleteModal
              modalActivator={modalActivator}
              description={getTranslatedText(
                intl,
                'mail.unknown.bulk.delete.description'
              )}
              handleDeleteConfirmation={() =>
                deleteUnknownEmails({
                  variables: {
                    unknownEmailIds: records.map((rec) => rec.unknownEmailId)
                  }
                }).then(() => {
                  setRecords([]);
                  EventEmitter.dispatch('refreshMailViewCount', [params.id]);
                })
              }
              title={getTranslatedText(intl, 'mail.unknown.bulk.delete.title')}
            />
          </ButtonGroup>
        )}
      </div>
    </ToolbarWrapper>
  );
}

function MailToolbar(props) {
  /*  Default active view will be all, it will served from server or constant, here it is temp fix*/
  const { intl, match, navMenu } = props;

  const context = useContext(TicketContext);
  const appContext = useContext(AppContext);
  const tableName = ALL_TABLES.unknownEmailTickets;
  const viewId = match.params.id;
  const activeView =
    match.params.id !== '18' ? 'Unknown emails' : 'Unknown tickets';

  const { records, setRecords } = useSuperListHook({
    viewId,
    tableName
  });

  return (
    <StyledToolbar className="fx actr">
      <TicketInfoToolbar
        intl={intl}
        toggleNavMenu={props.toggleNavMenu}
        navMenu={navMenu}
        params={match.params}
        activeView={activeView}
        context={context}
        location={props.location}
        entitiesMeta={props.entitiesMeta}
      />
      <MailActionToolbar
        intl={intl}
        params={match.params}
        activeView={activeView}
        context={context}
        appContext={appContext}
        location={props.location}
        records={records}
        setRecords={setRecords}
        tableName={tableName}
        viewId={viewId}
      />
    </StyledToolbar>
  );
}

export default injectIntl(withRouter(MailToolbar));
